<template>
  <span :class="['match-percentage', matchingClass]">{{ matchText }}</span>
</template>

<script>
export default {
  props: {
    percentage: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    matchingClass() {
      if (this.percentage > 70) return 'green'
      else if (this.percentage > 45) return 'orange'
      else return 'red'
    },
    matchText() {
      if (this.percentage == 100) return this.i18n.t('/FleetContracts/Details/FullMatch')
      else if (this.percentage > 0)
        return `${this.percentage} ${this.i18n.t('/FleetContracts/Details/PercentageMatch')}`
      else return this.i18n.t('/FleetContracts/Details/NoMatch')
    },
  },
}
</script>

<style lang="scss" scoped>
.match-percentage {
  margin: 0 0 0 auto;
  color: white;
  border-radius: 5px;
  padding: 0 12px;

  &.green {
    background-color: rgba(76, 175, 80, 0.9);
  }
  &.orange {
    background-color: #fc8826;
  }
  &.red {
    background-color: red;
  }
}
</style>
